import React from 'react';
import Panel from './Panel';
import css from './AdminPageSuperDeals.css';
import AdminPageHolder from '../AdminPanelsPage/AdminPageHolder';

const api = '/api/super-deals';

export default () => (
    <AdminPageHolder
        title="AdminPageSuperDeals"
        schema={{
            '@context': 'http://schema.org',
            '@type': 'AdminPanelsPage',
            description: 'Admin panel',
            name: 'Admin panel',
        }}
    >
        <h1 className={css.pageTitle}>Super deals</h1>
        <Panel api={api} />
    </AdminPageHolder>
);
